import React from "react";
import ReactDOM from "react-dom/client";
import FootballWidgets from "./components/FootballWidgets";
import CricketWidgets from "./components/CricketWidgets";
import TennisWidgets from "./components/TennisWidgets";
import BasketballWidgets from "./components/BasketballWidgets";
import RugbyWidgets from "./components/RugbyWidgets";
import GolfWidgets from "./components/GolfWidgets";
import HorseRacingWidget from "./components/HorseRacingWidget";
import IceHockeyWidgets from "./components/IceHockeyWidgets";
import Formula1Widgets from "./components/Formula1Widgets";
import InteractivesWidgets from "./components/InteractivesWidgets";

const mountWidget = (container) => {
  if (!container) return;

  const props = {
    dataId: container.getAttribute("data-id"),
    dataType: container.getAttribute("data-type"),
    sport: container.getAttribute("data-sport"),
    difference: container.getAttribute("data-difference"),
    baseUrl: container.getAttribute("data-base-url"),
    head: container.getAttribute("data-head"),
    date: container.getAttribute("data-date"),
    loadCSS: container.getAttribute("data-loadcss"),
    isLive: container.getAttribute("data-live"),
    dataTest: container.getAttribute("data-listingdata"),
    dataSSR: container.getAttribute("data-ssr"),
    websiteBaseUrl: container.getAttribute("data-websiteurl"),
    dataPath: container.getAttribute("data-path"),
    dataTitle: container.getAttribute("data-title"),
    dataClient: true,
  };

  const sport = props.sport;

  // Interactives: client-only, no hydration — use createRoot
  if (sport === "interactives") {
    const root = ReactDOM.createRoot(container);
    root.render(
      <InteractivesWidgets
        dataType={props.dataType}
        data={null}
        loadCSS={props.loadCSS}
        dataClient={true}
        websiteBaseUrl={props.websiteBaseUrl}
        dataPath={props.dataPath}
        containerEl={container}
      />
    );
    container.classList.add("hydrated");
    return;
  }

  const widgetMap = {
    cricket: CricketWidgets,
    football: FootballWidgets,
    rugby: RugbyWidgets,
    tennis: TennisWidgets,
    basketball: BasketballWidgets,
    golf: GolfWidgets,
    horseracing: HorseRacingWidget,
    icehockey: IceHockeyWidgets,
    formula1: Formula1Widgets,
  };

  const WidgetComponent = widgetMap[sport];

  if (WidgetComponent) {
    ReactDOM.hydrateRoot(container, <WidgetComponent {...props} />);
    container.classList.add("hydrated");
  } else {
    console.warn(`No widget found for sport: ${sport}`);
  }
};

// Mount all widgets on initial page load
document.querySelectorAll(".microservice-cont:not(.hydrated)").forEach(mountWidget);

// Expose for dynamically injected widgets (e.g. Next.js)
window.__MICRO_MOUNT = mountWidget;
